module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Leaderboard.91089ee5.svg";